
<div class="flow-widget-actions-wrapper">
	<div
		v-for="action in actions"
		:key="action.name"
		class="flow-widget-action"
		@click="handleActionClick(action)"
	>
		<span class="action-name">{{ action.name }}</span>
		<Icon
			:name="action.icon"
			class="cursor-pointer"
			state="dark"
			:effects="false"
			type="filled"
			size="small"
		/>
	</div>
</div>
